import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMkKeyBlack = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 250 250",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M108.89,249.74,104.3,249C43.74,239-.22,186.9-.22,125.21-.22,56,55.86-.26,124.78-.26s125,56.29,125,125.47c0,59.59-42.19,111.32-100.31,123l-4.72.95V190l-16.1-16.75,14.51-15.09L128,143.07l16.74-16.8V118.9L126.82,94.2l-17.93,24.7ZM124.78,7.65C60.21,7.65,7.67,60.39,7.67,125.21A117,117,0,0,0,101,240.33v-124l25.82-35.58,25.82,35.58v13.21l-13.45,13.51,15,15L139.6,173.23l13,13.56v52.63c52-12.73,89.25-60,89.25-114.21C241.89,60.39,189.36,7.65,124.78,7.65ZM77.18,176.13a71.18,71.18,0,0,1-22.05-51.74c0-39.54,32-71.7,71.42-71.7a71.71,71.71,0,0,1,49.39,123.44l-5.47-5.71a63.53,63.53,0,1,0-87.83,0Z",
		fill: "#000000",
		fillRule: "evenodd"
	})
});
export default SvgMkKeyBlack;
